(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ushoreNativeBuyNowFeedbackInitialized) return;

    window.ushoreNativeBuyNowFeedbackInitialized = true;

    const showImmediateFeedback = (event) => {
      const eventPath =
        typeof event.composedPath === 'function'
          ? event.composedPath()
          : [];

      const nativeCheckout = eventPath.find(
        (node) =>
          node instanceof Element &&
          (
            node.matches('shopify-accelerated-checkout') ||
            node.matches('.shopify-payment-button__button')
          )
      );

      const buyNow = nativeCheckout?.closest(
        '[data-ushore-native-buy-now]'
      );

      if (!buyNow) return;

      buyNow.classList.add('is-ushore-processing');

      window.clearTimeout(buyNow.ushoreFeedbackTimer);

      buyNow.ushoreFeedbackTimer = window.setTimeout(() => {
        buyNow.classList.remove('is-ushore-processing');
      }, 800);
    };

    document.addEventListener(
      'pointerdown',
      showImmediateFeedback,
      { passive: true }
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        showImmediateFeedback(event);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
